import { withAuthGuard } from "../../../routes/helpers";
import EnterEmail from "./userEmail";

const Onboarding = () => <EnterEmail />;

export default withAuthGuard(Onboarding);
